export default "__VITE_ASSET__B_k$IB5d__"